import CircularSettings from './Circular';
export default CircularSettings;